import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="games--bingo"
export default class extends Controller {
  tap ({ currentTarget }) {
    const cell = currentTarget.closest("[data-bingo-cell]")
    if (cell) {
      cell.classList.add("opacity-60", "pointer-events-none", "ring-2", "ring-secondary")
    }
  }
}
